<template>
  <div>
    <content-section-wrapper>
      <content-page-header
          back-link="/sveden"
          back-title="Сведения об образовательной организации"
          current-title="Образование"
      />
      <content-section
          title="Информация о реализуемых уровнях образования, о формах обучения, нормативных сроках обучения:">
        <p>
          Школа экспорта РЭЦ реализует образовательные программы профессионального обучения и дополнительного
          профессионального образования:
        </p>
        <ul>
          <li>
            программы повышения квалификации реализуются в объеме от 16 до 250 часов. Обучающимся, успешно освоившим
            программу и прошедшим итоговую аттестацию, выдается удостоверение о повышении квалификации
          </li>
          <li>
            программы профессиональной переподготовки реализуются в объеме более 250 часов. Обучающимся, успешно
            освоившим программу и прошедшим итоговую аттестацию, выдается диплом о профессиональной переподготовке
          </li>
        </ul>
      </content-section>

      <content-section title="Формы обучения">
        <p>Обучение проводится по очной, заочной, очно-заочной формам обучения с применением электронного обучения и
          дистанционных образовательных технологий. Форма обучения указывается в соответствующей образовательной
          программе</p>
        <p>
          <strong>Нормативные сроки обучения</strong> — в соответствии со сроками, указанными в договоре об оказании
          образовательных услуг.
        </p>
        <p>
          <strong>Государственная аккредитация</strong> — Государственная аккредитация не предусмотрена.
        </p>
      </content-section>

      <content-section title="Информация о языках, на которых осуществляется образование (обучение)">
        Обучение в Школе экспорта РЭЦ ведется на русском языке
      </content-section>

      <content-student-stats-table/>

      <content-section title="Информация о результатах приема">
        Прием на образовательные программы, реализуемые Школой экспорта РЭЦ, осуществляется в соответствии с
        заключенными договорами об оказании образовательных услуг
      </content-section>

      <content-section title="Информация о результатах перевода, восстановления и отчисления">
        В Школе экспорта РЭЦ перевод, отчисление и восстановление обучающихся не производились
      </content-section>

      <content-section title="Информация по образовательным программам">
        <content-table
            title="Информация по образовательным программам"
            :columns="columns"
            :rows="rows"
        />
      </content-section>

      <content-section title="Информация об адаптированных образовательных программах">
        Адаптированные образовательные программы (АОП) в Школе экспорта РЭЦ не реализуются в связи с отсутствием в
        контингенте обучающихся лиц с ограниченными возможностями здоровья (ОВЗ), желающих обучаться по АОП
      </content-section>
      <content-section title="Информация о направлениях и результатах научной (научно-исследовательской) деятельности и научно-исследовательской базе для ее осуществления">
        В Школе экспорта РЭЦ научная (научно-исследовательская) деятельность не ведется
      </content-section>
      <content-section title="Информация о трудоустройстве выпускников для каждой реализуемой образовательной программы, по которой состоялся выпуск">
        Школа экспорта РЭЦ не занимается трудоустройством обучившихся по образовательным программам
      </content-section>

      <content-section title="Методические и иные документы">
        <content-document-grid :documents="documents" class="mb-10"/>
      </content-section>

      <content-back/>

      <content-nav-wrapper>
        <company-navigation/>
      </content-nav-wrapper>
    </content-section-wrapper>
    <page-footer/>
  </div>
</template>

<script>
import PageFooter from "../../components/PageFooter";
import ApiService from "../../../services/api.service";
import CompanyNavigation from "../../components/CompanyNavigation";
import ContentSection from "@/components/content/ContentSection.vue";
import ContentStudentStatsTable from "@/components/content/ContentStudentStatsTable.vue";
import ContentTable from "@/components/content/ContentTable.vue";
import ContentDocumentGrid from "@/components/content/ContentDocumentGrid.vue";
import ContentBack from "@/components/content/ContentBack.vue";
import ContentNavWrapper from "@/components/content/ContentNavWrapper.vue";
import ContentPageHeader from "@/components/content/ContentPageHeader.vue";
import ContentSectionWrapper from "@/components/content/ContentSectionWrapper.vue";

export default {
  name: "InfoEdu",
  components: {
    ContentSectionWrapper,
    ContentPageHeader,
    ContentNavWrapper,
    ContentBack,
    ContentTable,
    ContentStudentStatsTable,
    ContentSection,
    ContentDocumentGrid,
    CompanyNavigation,
    PageFooter
  },
  data() {
    return {
      blocks: null,
    }
  },
  mounted() {
    ApiService.get('infocategories/education').then(res => {
      this.blocks = res.data.info_blocks
      this.$parent.init()
    })
  },
  computed: {
    columns() {
      return [
        'Уровень образования',
        'Наименование образовательной программы',
        'Реализуемые формы обучения',
        'Нормативный срок обучения<br>(в академических часах)',
        'Язык обучения',
        'Образовательная программа',
        'Учебный план',
        'Календарный учебный график',
        'Ссылка на рабочие программы практик'
      ]
    },
    rows() {
      return [
        [
          'Дополнительное образование – повышение квалификации',
          'Старт экспортной деятельности: 10 шагов к успеху',
          'Заочная с применением электронного обучения и дистанционных образовательных технологий',
          '100',
          'Русский',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/71fb2af337b2ab61a39a0156bd9f12fbc4196649.pdf" target="_blank">Образовательная программа</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/173815f525a8573393d418edacdd5c4877aafd0a.pdf" target="_blank">Учебный план</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/6d1b765d726e4666e2bdf016c302dc34927ed1f9.pdf" target="_blank">График</a>',
          'Практики не предусмотрены'
        ],
        [
          'Дополнительное образование – повышение квалификации',
          'Акселератор экспортного роста',
          'Очная с применением электронного обучения и дистанционных образовательных технологий',
          '216',
          'Русский',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/f8417506975a15fdce5b34a4e43717b9cea5f38e.pdf" target="_blank">Образовательная программа</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/bc407e813c96b7a68243120824c41137d398e0be.pdf" target="_blank">Учебный план</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/f77e573357132d85f2d5a7c2ea36a906f9825398.pdf" target="_blank">График</a>',
          'Практики не предусмотрены'
        ],
        [
          'Дополнительное образование – повышение квалификации',
          'Экспорт регионов 2.0',
          'Очно-заочная с применением электронного обучения и дистанционных образовательных технологий',
          '135',
          'Русский',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/8658f2d46130053ee1cd92e841813691a5b36e8d.pdf" target="_blank">Образовательная программа</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/0259476edae1d0515ebc6f6370701d8954db103f.pdf" target="_blank">Учебный план</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/2961943719dfffe020b86120eb57b7758304dbe1.pdf" target="_blank">График</a>',
          'Практики не предусмотрены'
        ],
        [
          'Дополнительное образование – повышение квалификации',
          'Организация экспортной деятельности российских предприятий для тренеров',
          'Очно-заочная с применением электронного обучения и дистанционных образовательных технологий',
          '202',
          'Русский',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/54978981fcfd04d8956900e26c95540d2ce32c92.pdf" target="_blank">Образовательная программа</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/4f1b69fe34e9db4276326247571e63b0e26bb4d1.pdf" target="_blank">Учебный план</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/5bd1a1bbc2765f4549d5485815cb63c0d0d38dfa.pdf" target="_blank">График</a>',
          'Практики не предусмотрены'
        ],
        [
          'Дополнительное образование – повышение квалификации',
          'Бизнес с Китаем: экспортные стратегии и инструменты',
          'Очно-заочная с применением электронного обучения и дистанционных образовательных технологий',
          '88',
          'Русский',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/941f463fb9dd347913fafbdef83f39c990c7f69f.pdf" target="_blank">Образовательная программа</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/bf919e5f6f9786c17ccda069661423cb4660a36d.pdf" target="_blank">Учебный план</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/4a579a491ead90c75d7e7e87655f3b0ebda9dd60.pdf" target="_blank">График</a>',
          'Практики не предусмотрены'
        ],
        [
          'Дополнительное образование – повышение квалификации',
          'Новый экспорт в текущих условиях',
          'Очная с применением электронного обучения и дистанционных образовательных технологий',
          '24',
          'Русский',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/9d21afd164f10ef61d2d66ec85f87e7d4343236a.pdf" target="_blank">Образовательная программа</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/52d13a11d33060241902b3e159e326072e22b010.pdf" target="_blank">Учебный план</a>',
          '<a href="//exporteduru.servicecdn.ru/media/default/0003/43/171f16ab9b2429d493ed9dbf7682f2920b5d19e5.pdf" target="_blank">График</a>',
          'Практики не предусмотрены'
        ]
      ];
    },
    documents() {
      return [
        {
          title: 'Положение об организации и осуществления обр. деятельности по ДПП',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0001/79/f8a1e7cd35b978f78c8ac67a03a7b13d7e6f7788.pdf'
        },
        {
          title: 'Положение об организации и осуществления обр. деятельности по ДПП - ЭЦП',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0002/60/48994dd3951cbb9ee62b10f885e6dba861f13b67.pdf'
        },
        {
          title: 'Положение об осуществлении текущ. контроля и промежуточной аттестации',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0001/10/fe413edd34b6fb0c1f7fc75a64291f58d521dd1a.pdf'
        },
        {
          title: 'Положение об осуществлении текущ. контроля и промежуточной аттестации - ЭЦП',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0002/60/7ca5e7bde3d89366f05d38529e6dfff830707c33.pdf'
        },
        {
          title: 'Положение об итоговой аттестации',
          link: 'https://exporteduru.servicecdn.ru/media/document/0001/11/b2a60364ba00ec14293ce7636baee48e783a6401.pdf'
        },
        {
          title: 'Положение об итоговой аттестации - ЭЦП',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0002/60/7ca5e7bde3d89366f05d38529e6dfff830707c33.pdf'
        },
        {
          title: 'Приказ о порядке заполнения, учета и выдачи документов об образовании и о квалификации',
          link: 'https://exporteduru.servicecdn.ru/media/default/0001/13/7131f3736fbbfee3c82299f72570e68812a55daa.pdf'
        },
        {
          title: 'Приказ о порядке заполнения, учета и выдачи документов об образовании и о квалификации - ЭЦП',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0002/60/3d8eb09a75cda4598b90efc44570ed7f6015f110.pdf'
        },
        {
          title: 'Положение о порядке заполнения, учета и выдачи документов об образовании и о квалификации',
          link: 'https://exporteduru.servicecdn.ru/media/document/0001/11/137d4a6ae99a1cfc69f272e05ca36763935a61d8.pdf'
        },
        {
          title: 'Положение о применении электронного обучения и дистанционных обр. технологий',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0001/16/5236cec52441e9d24362ff70a21d2e59cea18d8e.pdf'
        },
        {
          title: 'Положение об информационной открытости',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0001/01/ec2ceef14f7cc9670b36c6593ca4ae25323734f9.pdf'
        },
        {
          title: 'Численность обучающихся - ЭЦП',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0002/64/add935da9a8d82146e8aa38056be63fa9b14c556.pdf'
        },
        {
          title: 'Календарный учебный график на 2022 год',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0002/60/db0cee41acb4886cdd608fbf4d04d411d8e68741.pdf'
        },
        {
          title: 'Календарный учебный график на 2023 год',
          link: 'https://exporteduru.servicecdn.ru/media/default/0002/92/cc962cdff86f0c580a0f69913cb1c30b2f425cc7.pdf'
        },
        {
          title: 'Положение о модульно-накопительной системе повышения квалификации',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0001/79/6a5f815c78b2af36e5aceda1c777a52f894193b6.pdf'
        },
        {
          title: 'Положение о модульно-накопительной системе повышения квалификации - ЭЦП',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0002/60/6ff98d12c829f0564568ce5729bc65dd4650aea7.pdf'
        },
        {
          title: 'Положение о порядке подтверждения квалификации региональных тренеров Школы экспорта',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0001/79/bb5d2ede642834e1a3e195c58f34e62e09cbeeab.pdf'
        },
        {
          title: 'Положение о порядке подтверждения квалификации региональных тренеров Школы экспорта - ЭЦП',
          link: 'https://exporteduru.servicecdn.ru/media/attachment/0002/60/036ed09bf58873163a74130639690304f1c963ff.pdf'
        }
      ];
    }
  }
}
</script>
